import { Box, Stack } from "@mui/material";
import { Custom, FormFeedback, Workflow } from "components";
import { Utils } from "components/workflow";
import { useApp, useService, useSession, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { Auxiliars } from "helpers";
import { IFeedback, IUser, createDefaultFeedback } from "interfaces";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Enums } from "utils";
import { createStep } from "utils/helpers";

const StepFeedback = forwardRef((_, ref) => {
  const { current, data, updateData, pushFlow, nextStep } =
    useWorkflow<Workflow.Utils.PotluckType>();
  const { theme } = useTheme();
  const { t } = useApp();

  const hanldeOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateData("feedback." + event.target.name, event.target.value);
  };

  const handleOnSkip = () => {
    updateData("feedback", "");
    nextStep();
  };

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.shared.feedback.header}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.xs}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.shared.feedback.headline}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.shared.feedback.description}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <FormFeedback.Fields
            t={t}
            values={data.feedback}
            onChange={hanldeOnChange}
          />
        </Stack>
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.PotluckType>(StepFeedback, {
  skippable: true,
});
